/* eslint-disable */
(function() {
  var $ = require('jquery');
  var $animElem = $('.js-entry-anim');
  var ACTIVE = 'is-active';

  if ($animElem.length) {
    var windowHeight = $(window).height();
    var gridTop = windowHeight * 0.8;

    $(window).on('scroll', function() {
      $animElem.each(function() {
        var thisTop = $(this).offset().top - $(window).scrollTop();
        if (thisTop < gridTop) {
          $(this).addClass(ACTIVE);
        }
      });
    });
  }
})();
